export default __webpack_public_path__ + "static/media/goToBackBlue.e945c1d8.svg";